import styled from "styled-components";

const StyledTitleFCA = styled.span`
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 38px;
    overflow: hidden;
    flex: 1;
`;

export default StyledTitleFCA;

